import { onMounted, getCurrentInstance } from 'vue';

export default function useElectronOnActivated() {
  if (!window.electronAPI) {
    return;
  }
  const getActivatedCallbacks = (instance: any) => {
    if (!instance) return [];

    // Get component's internal hooks
    const { a: activated } = instance;

    // Return activated hooks array or empty array if none exist
    return activated || [];
  };

  const instance = getCurrentInstance();

  onMounted(() => {
    const activatedHooks = getActivatedCallbacks(instance);
    console.log('Activated callbacks:', activatedHooks);
    window.electronAPI.onViewFocus(() => {
      activatedHooks.forEach((hook: () => void) => hook());
    });
  });
}
